// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioMutedOutlinedSvg from "@fishx/icons-svg/es/asn/AudioMutedOutlined";
import FishxIcon from '../components/FishxIcon';

var AudioMutedOutlined = function AudioMutedOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioMutedOutlinedSvg
  }));
};

AudioMutedOutlined.displayName = 'AudioMutedOutlined';
export default React.forwardRef(AudioMutedOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AudioMutedOutlined.js
// module id = 2034
// module chunks = 0